import React from 'react';
import OrderImportForm from './orders/OrderImportForm';
import './OrderImport.css';

const OrderImport = () => {
  return (
    <div className="order-import-container">
      <OrderImportForm />
    </div>
  );
};

export default OrderImport;
